"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
    t = (e = require("react")) && "object" == typeof e && "default" in e ? e.default : e;

function r() {
  r = function r(e, t) {
    return new n(e, void 0, t);
  };

  var e = RegExp.prototype,
      t = new WeakMap();

  function n(e, r, i) {
    var l = new RegExp(e, r);
    return t.set(l, i || t.get(e)), a(l, n.prototype);
  }

  function l(e, r) {
    var n = t.get(r);
    return Object.keys(n).reduce(function (t, r) {
      return t[r] = e[n[r]], t;
    }, Object.create(null));
  }

  return i(n, RegExp), n.prototype.exec = function (t) {
    var r = e.exec.call(this, t);
    return r && (r.groups = l(r, this)), r;
  }, n.prototype[Symbol.replace] = function (r, n) {
    if ("string" == typeof n) {
      var i = t.get(this);
      return e[Symbol.replace].call(this, r, n.replace(/\$<([^>]+)>/g, function (e, t) {
        return "$" + i[t];
      }));
    }

    if ("function" == typeof n) {
      var a = this;
      return e[Symbol.replace].call(this, r, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(l(e, a)), n.apply(this, e);
      });
    }

    return e[Symbol.replace].call(this, r, n);
  }, r.apply(this, arguments);
}

function n() {
  return (n = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function i(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && a(e, t);
}

function a(e, t) {
  return (a = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function l(e, t) {
  if (null == e) return {};
  var r,
      n,
      i = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    t.indexOf(r = a[n]) >= 0 || (i[r] = e[r]);
  }

  return i;
}

var u = ["children"],
    o = ["src", "url", "sizes", "variants", "altText", "alt", "caption", "className", "media", "_availableSizes", "_availableFormats"];

function c(e) {
  return e.url + " " + e.width + "w";
}

exports.Image = function (e) {
  var i,
      a,
      s,
      p,
      f = e.children,
      h = l(e, u),
      v = h.src,
      m = h.url,
      g = h.sizes,
      d = h.variants,
      y = h.altText,
      b = h.alt,
      j = h.caption,
      w = h.className,
      S = h.media,
      E = h._availableSizes,
      x = h._availableFormats,
      z = l(h, o),
      O = (d || []).filter(function (e) {
    return !!e;
  }),
      _ = "string" == typeof b ? b : y;

  if (m && E && x) {
    O = [];
    var W = m.replace(/\.[^/]+$/, "").match(/(.+)(\/)([^/]+)$/);

    if (W) {
      var T = W[1],
          $ = W[3];
      E.forEach(function (e) {
        x.forEach(function (t) {
          O.push({
            url: T + "/@" + e + "/" + $ + "." + t,
            width: e
          });
        });
      });
    }
  }

  var N = O.length > 0,
      P = O[0];
  N && (P = O.reduce(function (e, t) {
    return !e.width || t.width > e.width ? t : e;
  }, O[0]));
  var k = O.filter(function (e) {
    return e.url && !e.url.endsWith(".webp") && !e.url.endsWith(".avif");
  }),
      F = O.filter(function (e) {
    return e.url && e.url.endsWith(".webp");
  }),
      M = O.filter(function (e) {
    return e.url && e.url.endsWith(".avif");
  }),
      R = k.map(c).join(", "),
      A = F.map(c).join(", "),
      I = M.map(c).join(", "),
      q = "jpeg";

  if (k.length > 0) {
    var H,
        L = k[0].url.match(r(/\.((?:(?!\.)[\s\S])+)$/, {
      name: 1
    }));
    "jpg" === (q = (null == L || null == (H = L.groups) ? void 0 : H.name) || "jpeg") && (q = "jpeg");
  }

  var B = {
    src: v || m || (N ? k[0].url : void 0),
    alt: _,
    caption: j,
    width: null == (i = P) ? void 0 : i.width,
    height: null == (a = P) ? void 0 : a.height
  },
      C = A.length > 0,
      D = I.length > 0;

  if (C && D) {
    var G = F[0],
        J = M[0];
    G.size && J.size && (D = G.size > J.size);
  }

  if (f) return f(n({
    srcSet: R,
    srcSetWebp: A,
    srcSetAvif: I,
    useAvif: D,
    useWebP: C,
    className: w,
    sizes: g,
    media: S
  }, B, z, {
    originalFileExtension: q
  }));
  var K = (null == j || null == (s = j.html) ? void 0 : s[0]) || (null == j || null == (p = j.plainText) ? void 0 : p[0]) || "";
  return t.createElement("figure", {
    className: w
  }, t.createElement("picture", null, D && t.createElement("source", {
    srcSet: I,
    type: "image/avif",
    sizes: g,
    media: S
  }), C && t.createElement("source", {
    srcSet: A,
    type: "image/webp",
    sizes: g,
    media: S
  }), R.length > 0 && t.createElement("source", {
    srcSet: R,
    type: "image/" + q,
    sizes: g,
    media: S
  }), t.createElement("img", Object.assign({}, B, z))), K && t.createElement("figcaption", {
    dangerouslySetInnerHTML: {
      __html: K
    }
  }));
};